import { FC } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from 'elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';

const TheComp: FC = () => {
    const { pageStatus } = useDP3Store();
    const { t } = useLang(pageStatus === 'statusA' ? 'dp3.teaser.Banner' : 'dp3.landing.Banner');

    const [gap, setGap] = useState(18);
    const isPre = pageStatus === 'statusA';
    const cards = [
        {
            label: isPre ? 'Coming Soon' : '',
            title: isPre ? '' : 'Starter Kit',
            name: 'EcoFlow DELTA Pro 3 + DELTA Pro 3 Smart Extra Battery',
            power: '',
            desc: 'Extended Ease Kit',
            img: 'https://websiteoss.ecoflow.com/upload/image/1726667413478/d1.png',
            productId: '8311879925958',
            variantId: '44062870536390',
            originalPrice: isPre ? 10599 : null,
            discountPrice: isPre ? 7299 : null,
        },
        {
            label: isPre ? 'Coming Soon' : '',
            title: isPre ? '' : 'Starter Kit',
            name: 'EcoFlow DELTA Pro 3 + 800W Alternator Charger',
            power: '',
            desc: 'Power On-the-go',
            img: 'https://websiteoss.ecoflow.com/upload/image/1727404147639/d2.png',
            productId: '8311879925958',
            variantId: '44062870634694',
            originalPrice: isPre ? 7498 : null,
            discountPrice: isPre ? 4599 : null,
        },
        {
            label: isPre ? 'Coming Soon' : '',
            title: isPre ? '' : 'Starter Kit',
            name: 'EcoFlow DELTA Pro 3 + 400W Solar Panel',
            power: '',
            desc: 'Solar-Powered Freedom',
            img: 'https://websiteoss.ecoflow.com/upload/image/1726667413143/d3.png',
            productId: '8311879925958',
            variantId: '44062870601926',
            originalPrice: isPre ? 7899 : null,
            discountPrice: isPre ? 5199 : null,
        },
        {
            label: isPre ? 'Coming Soon' : '',
            title: isPre ? '' : 'Starter Kit',
            name: 'EcoFlow DELTA Pro 3 + WAVE 2',
            power: '',
            desc: 'Ultimate Climate Control',
            img: 'https://websiteoss.ecoflow.com/upload/image/1726667413667/d4.png',
            productId: '8311879925958',
            variantId: '44062870667462',
            originalPrice: isPre ? 8698 : null,
            discountPrice: isPre ? 5699 : null,
        },
    ];

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const props = {
        needTerms: true,
        isMulti: true,
        termsHtml: `* I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-au/TermsOfUse.html" target="_blank">Terms of Service</a>.`,
        contactListId: ['1273707010'],
        fields: [
            {
                id: '11571',
                type: 'multiple',
                value: [1],
                overwrite: false,
            },
        ],
        tipsObj: {
            placeholder: t('placeholder'),
            successTips: 'Thank you for subscribing!',
        },
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 18 : window.innerWidth < 768 ? 10 : 14);
        }
    }, []);

    return (
        <div className={`${css.thecomp}`}>
            <p className="title">Check out these EcoFlow DELTA Pro 3 solutions for different scenarios</p>
            <Swiper
                className={`swiper-box`}
                // navigation={true}
                // pagination={true}
                // loop={true}
                spaceBetween={gap}
                // autoplay={{
                //     delay: 3000,
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: true,
                // }}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {cards.map((card, k) => (
                    <SwiperSlide className={`swiper-card`} key={k}>
                        <div className="card-img">
                            <EfImg pc={card?.img} />
                        </div>
                        <div className="card-info">
                            {card?.label && <p className="card-label">{card.label}</p>}
                            {card?.name && <p className="card-name">{card.name}</p>}
                            {card?.desc && <p className="card-desc">{card.desc}</p>}
                            <div className="card-price">
                                <span className="discount-price">{FormatMoneyLocal(card?.discountPrice, 'au')}</span>
                                {card?.discountPrice !== card?.originalPrice && (
                                    <span className="original-price">{FormatMoneyLocal(card?.originalPrice, 'au')}</span>
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {isPre && <EfEmarsysEmail {...props} />}
        </div>
    );
};

export default TheComp;
